import React from 'react';
import { Spin } from 'antd';
import FeatureLockedPage from '../components/FeatureLockedPage';
import type { FeatureKey } from './registry';
import { useFeature } from './useFeature';

interface FeatureRouteProps {
  name: FeatureKey;
  children: React.ReactNode;
  /**
   * O que mostrar com a flag desligada. Ausente = `FeatureLockedPage` (o
   * comportamento de sempre). Existe para a feature em dark launch que NÃO
   * pode exibir CTA de plano (ex.: `linkedin_import`, Anexo C §2: "sem erro,
   * sem toast e sem CTA de plano").
   */
  fallback?: React.ReactNode;
}

/**
 * Route guard for feature-flag gated pages. While the flag bundle is still
 * resolving we render a centred spinner — never redirect — so a
 * not-yet-loaded flag can't masquerade as "feature disabled". When the
 * feature is genuinely off (typically because the tenant's plan doesn't
 * include it), we render the upsell paywall instead of silently
 * navigating away.
 */
export function FeatureRoute({ name, children, fallback }: FeatureRouteProps) {
  const { enabled, loading } = useFeature(name);
  if (loading) {
    return (
      <div style={{ padding: 48, textAlign: 'center' }}>
        <Spin />
      </div>
    );
  }
  if (!enabled) return fallback !== undefined ? <>{fallback}</> : <FeatureLockedPage feature={name} />;
  return <>{children}</>;
}
